import { FC, useEffect, useState } from 'react';
import Modal from 'components/shared/Modal';
import { useG2ReviewContext } from 'app/context/G2ReviewContext';
import { useTranslation } from 'react-i18next';
import { ActivityIndicator } from '@kontentino/ui';

const G2ReviewModal: FC = () => {
  const { iframeUrl, closeG2ReviewModal } = useG2ReviewContext();
  const { t } = useTranslation();
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  useEffect(() => {
    if (iframeUrl) {
      setIsIframeLoading(true);
    }
  }, [iframeUrl]);

  return (
    <Modal
      open={iframeUrl !== null}
      onClose={closeG2ReviewModal}
      classNames={{ modal: '  !tw-h-full' }}
      dataName={{ wrapper: 'g2-review-modal' }}
      dataCy={{ wrapper: 'g2-review-modal' }}
      size="lg"
    >
      <Modal.Header title={t('g2Review.writeReview')} />
      <Modal.Content>
        {iframeUrl && (
          <div className="tw-relative tw-h-[600px] tw-w-full">
            {isIframeLoading && (
              <div
                className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-white"
                data-cy="g2-review-modal_loading"
              >
                <ActivityIndicator className="tw-h-12 tw-w-12" />
              </div>
            )}
            <iframe
              src={iframeUrl}
              className="tw-h-full tw-w-full tw-border-0"
              title={t('g2Review.writeReview')}
              onLoad={() => setIsIframeLoading(false)}
              data-cy="g2-review-modal_iframe"
            />
          </div>
        )}
      </Modal.Content>
    </Modal>
  );
};

export default G2ReviewModal;
